import apiUrl from '../../../constants.js'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper.js';
import moment from 'moment'
import {
    BasicSelect
} from 'vue-search-select';
import keycloak from '../../../common/Keycloak';
import { Fetchrvpholdshipmenttobereturned } from "../../../../services/modules/rvpholdreturnservices.js";

export default {
    name: 'RVPHoldReturn',
    components: {
        VueElementLoading,
        BasicSelect
    },
    mixins: [PageTracker],
    data: function () {
        return {
            username: '',
            hubId: '',
            localuserid: '',
            isLoading: false,
            /* UserRole */
            userrole: "",
            userDataKey: '',
            /* To be Return shipment list */
            tobereturnshipmentlist: [],

            /* Sr list Params */
            srArrayList: [],
            srList: [],
            srListFlt: [],
            fromDate: this.formatDate(new Date()), // sets default to today
            srItemObj: { value: "", text: "" },
            srId: '',
            srName: '',
            isLoadingtable: false

        }
    },
    filters: {
        dateFormat: function (date) {
            if (date == null || date == '')
                return '-'
            return moment(date).format('DD-MM-YYYY HH:mm:ss');
        }
    },
    created: function () { },
    computed: {
        currentDate() {
            return this.formatDate(new Date()); // used as max date
        }
    },
    async mounted() {
        localStorage.removeItem('printRoute')
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);

        this.username = userdetail.username;
        this.localuserid = userdetail.userid;
        this.hubId = userdetail.hubdetails[0];
        this.userrole = userdetail.userrole[0].rolename;
        this.loadSRList(this.hubId)
    },
    methods: {
        /* Load Sr List */
        loadSRList(hubid) {
            this.isLoading = true;
            this.srArrayList = []
            this.srList = []
            this.srListFlt = []
            if (hubid) {
                this.input = {
                    "usertype": "3",
                    "hubid": [hubid]
                }
                let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
                if (keycloak.enableKavach) {
                    apiendpoint = 'user/migration/gethubdeliveryuserlist';
                }
                axios({
                    method: 'POST',
                    url: apiUrl.api_url + apiendpoint,
                    data: this.input
                })
                    .then(result => {
                        //console.log('result.data',result.data.data.);
                        if (result.data.data.code == 200) {
                            this.srArrayList = result.data.data.results;

                            for (var i = 0; i < this.srArrayList.length; i++) {
                                this.srList.push({
                                    value: this.srArrayList[i].userid,
                                    text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                                })
                            }
                        } else {
                            this.$alertify.error(result.data.data.message ? result.data.data.message : 'No Record found')
                        }
                        this.isLoading = false
                    }, error => {
                        this.isLoading = false
                        console.error(error)
                    })
            } else {
                this.isLoading = false
                this.$alertify.error("Current Hub Id not found.")
            }
        },
        formatDate(date) {
            const d = new Date(date);
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const year = d.getFullYear();
            return `${year}-${month}-${day}`;
        },
        async selectSR(obj) {
            this.hideAllocateFlag = true;
            this.srCODPendingMsg = '';
            this.isShowCODAmount = false;
            this.ActiveTabIndex = 0;
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.fieldErr = false
            this.startTripFlag = false
            this.deliveryOptionItemObj = { text: "" }
            this.deliveryOption = ""
            //this.pendingShipmentList = []
            //this.totalPendingShipment = 0
            this.srItemObj = obj
            this.srId = obj.value
            this.srName = obj.text
        },
        rvpholdreturnshipments() {
            this.isLoadingtable = true;
            let requestPayload = {
                "hubId": this.hubId
            }
            if (this.srId) {
                requestPayload.srId = this.srId;
            } else {
                this.isLoadingtable = false;
                this.$alertify.error("DeliveryUserID is required");
                return
            }
            if (this.fromDate) {
                requestPayload.fromDate = this.fromDate;
            } else {
                this.isLoadingtable = false;
                this.$alertify.error("Date is required")
                return
            }

            Fetchrvpholdshipmenttobereturned(requestPayload, (result) => {
                if (result.data.code == 200 && result.data.toBeReturnShipments && result.data.toBeReturnShipments.length > 0) {
                    this.isLoadingtable = false;
                    this.tobereturnshipmentlist = result.data.toBeReturnShipments;
                } else if (result.data.code != 200) {
                    this.isLoadingtable = false;
                    this.tobereturnshipmentlist = []
                    this.$alertify.error(result.data.message)
                } else {
                    this.isLoadingtable = false;
                    this.tobereturnshipmentlist = []
                    this.$alertify.error("Record Not Found")
                }
            })
        },
        resetForm() {
            this.srItemObj = { value: "", text: "" };
            this.srId = '';
            this.srName = '';
            this.tobereturnshipmentlist = [];
            this.fromDate = this.formatDate(new Date())
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/RVPHoldReturn/RVPHoldReturn.component.js